var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext } from "react";
import { BigNumber } from "ethers";
import { RibbonTokenAddress, VaultLiquidityMiningMap, } from "../constants/constants";
import { SubgraphDataContext } from "./subgraphDataContext";
export var rbnTokenGraphql = function (account) { return "\n  rbntoken(id:\"" + RibbonTokenAddress.toLowerCase() + "\") {\n    name\n    symbol\n    numHolders\n    holders\n    totalSupply\n    totalStaked\n  }\n  tokenMinterDistributions(where: { id_in: [\n    " + Object.values(VaultLiquidityMiningMap.lg5)
    .map(function (address) { return "\"" + address.toLowerCase() + "\""; })
    .join(", ") + "\n  ]}) {\n    id\n    amount\n  }\n  " + (account
    ? "\n      rbnaccount(id:\"" + account.toLocaleLowerCase() + "\") {\n        totalBalance\n        lockedBalance\n        lockStartTimestamp\n        lockEndTimestamp\n      }\n    "
    : "") + "\n"; };
export var resolveRBNTokenSubgraphResponse = function (response) {
    if (response) {
        var rbntoken = response.rbntoken;
        var totalSupply = rbntoken.totalSupply, totalStaked = rbntoken.totalStaked, others = __rest(rbntoken, ["totalSupply", "totalStaked"]);
        return __assign(__assign({}, others), { totalStaked: totalStaked ? BigNumber.from(totalStaked) : undefined, totalSupply: BigNumber.from(totalSupply) });
    }
    return undefined;
};
export var resolveRBNTokenAccountSubgraphResponse = function (response) {
    if (response === null || response === void 0 ? void 0 : response.rbnaccount) {
        var rbnaccount = response.rbnaccount, others = __rest(response, ["rbnaccount"]);
        return __assign(__assign({}, rbnaccount), { token: resolveRBNTokenSubgraphResponse(others), lockStartTimestamp: rbnaccount.lockStartTimestamp === undefined
                ? undefined
                : Number(rbnaccount.lockStartTimestamp), lockEndTimestamp: rbnaccount.lockEndTimestamp === undefined
                ? undefined
                : Number(rbnaccount.lockEndTimestamp), totalBalance: BigNumber.from(rbnaccount.totalBalance), lockedBalance: BigNumber.from(rbnaccount.lockedBalance) });
    }
    return undefined;
};
export var resolveRbnDistributedSubgraphResponse = function (response) {
    if (response === null || response === void 0 ? void 0 : response.tokenMinterDistributions) {
        var distributionsPerGauge = response.tokenMinterDistributions;
        return distributionsPerGauge.reduce(function (prev, dist) {
            return prev.add(BigNumber.from(dist.amount));
        }, BigNumber.from(0));
    }
    return BigNumber.from(0);
};
export var useRBNToken = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.governanceSubgraphData.rbnToken,
        loading: contextData.governanceSubgraphData.loading,
    };
};
export var useRBNTokenAccount = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.governanceSubgraphData.rbnTokenAccount
            ? __assign(__assign({}, contextData.governanceSubgraphData.rbnTokenAccount), { walletBalance: contextData.governanceSubgraphData.rbnTokenAccount.totalBalance.sub(contextData.governanceSubgraphData.rbnTokenAccount.lockedBalance) }) : undefined,
        loading: contextData.governanceSubgraphData.loading,
    };
};
export var useRbnTokenDistributed = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        data: contextData.governanceSubgraphData.rbnTokenDistributedLg5,
        loading: contextData.governanceSubgraphData.loading,
    };
};
//# sourceMappingURL=useRBNTokenSubgraph.js.map